module.exports = __webpack_public_path__ + "static/media/RI-D1-7.3-072.26364f60.webp";